export enum ActiveTab {
  PREVIEW = 'preview',
  STATS = 'stats',
}
